import { render, staticRenderFns } from "./chat-toast.vue?vue&type=template&id=03bd34ae&scoped=true&"
import script from "./chat-toast.vue?vue&type=script&lang=js&"
export * from "./chat-toast.vue?vue&type=script&lang=js&"
import style0 from "./chat-toast.vue?vue&type=style&index=0&id=03bd34ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd34ae",
  null
  
)

export default component.exports